module.exports = __webpack_public_path__ + "static/img/cont51 (2).27ecb61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont51 (2).jpg
// module id = uw4v
// module chunks = 0